import useScreenWidthByUA from '@/utils/hooks/useScreenWidthByUA';
import type { IProps } from '../../IComponent';
import React from 'react';
import getGlobal from '@/utils/shared/getGlobal';
import NavSelect from '@/basic/NavSelect/render';
import CommonBox from '@/basic/CommonBox/CommonBox';
import './index.less';
const HEADER_HEIGHT = 88;

const FixedTopCategoryNav: React.FC<IProps> = (props) => {

    // eslint-disable-next-line react/destructuring-assignment
    const {
        storeCategoryId,
        ctx,
        categoryList,
        allText
    } = props;

    const screenWidth = useScreenWidthByUA(ctx?.headers?.userAgent);

    const [scrolled, setScrolled] = React.useState(false);

    // 吸顶样式
    const fixedStyle = React.useMemo(() => {
        if (scrolled) {
            return 'category-fixed show-category';
        }
        else {
            return 'category-fixed';
        }

    }, [ scrolled]);

    const lastKnownScrollPosition = React.useRef(0);
    const ticking = React.useRef(false);

    const listenScroll = React.useCallback(() => {
        lastKnownScrollPosition.current = window.scrollY;
        if (!ticking.current) {
            window.requestAnimationFrame(function() {
                if (!scrolled && lastKnownScrollPosition.current > HEADER_HEIGHT) {
                    setScrolled(true);
                }
                else if (scrolled && lastKnownScrollPosition.current < HEADER_HEIGHT) {
                    setScrolled(false);
                }
                ticking.current = false;
            });

            ticking.current = true;
        }
    }, [scrolled]);

    // 添加滚动的监听事件
    React.useEffect(() => {
        document.addEventListener('scroll', listenScroll);

        return () => {
            document.removeEventListener('scroll', listenScroll);
        
        };
    }, [listenScroll]);

    // 如果刷新之后当前滚动条不在顶部，那么初始化时就需要显示出来
    React.useEffect(() => {
        if (getGlobal().scrollY > HEADER_HEIGHT) {
            setScrolled(true);
        }
    }, []);

    const onChange = React.useCallback((val: string) => {
        window.location.href = categoryList.find(item => item.name ===  val)?.link ?? '';
    }, [categoryList]);

    const renderSelect = React.useCallback(() => screenWidth >= 1280 ?
        (
            <div className={ 'nav_container' }>
                <ul className={ 'product_cate_nav' }>
                    {
                        categoryList.map((item) => (
                            <li key={ item.name }>
                                <a
                                    href={ item.link }
                                    className={ `cate_item ${storeCategoryId === item.id ? 'cate_item_active' : ''}` }
                                >
                                    <p>{item.name}</p>
                                </a>
                            </li>
                        )
                        )
                    }
                </ul>
            </div>
        ) :
        (
            <div className={ 'nav_select_wrap' }>
                <NavSelect
                    placeholder={  allText }
                    list={ categoryList }
                    onChange={ onChange }
                    value={ storeCategoryId ?? '' }
                >
                </NavSelect>
            </div>
        ), [categoryList, onChange,  allText, screenWidth, storeCategoryId]);

    return (
        <CommonBox
            style={ props.style }
        >
            <div className={ `nav_wrap ${fixedStyle}` }>
                {renderSelect()}
            </div>
        </CommonBox>
    );
};

export default FixedTopCategoryNav;
